export function Images(props) {
    return (<>
        <div className="People dflex flexd-column alignitems mt-2" style={{textAlign:"center"}}>
            <img src={props.Image} alt="Pic1" />
            <span style={{maxWidth:"250px"}} className={props.SpanClass}>{props.Name}</span>
            <p style={{maxWidth:"250px"}}>{props.Position}</p>
        </div>
    </>)
}

export function Title(props) {
    // useEffect(() => {
    //         AOS.init({
    //         //   duration: 500, // global duration for animations (optional)
    //         //   once: true,     // animation happens only once while scrolling down
    //         });
    //       }, []);data-aos="fade-up" data-aos-duration="1000"
    return (<>
        <div className="NCP-Gallery-Title mt-4" >
            <span></span>
            <div className={props.className}>{props.Title}</div>
            <span></span>
        </div>
    </>)
}